import { DataType } from 'components/table/types';

export type tableColumns = Record<string, DataType>;
export const tableColumns: tableColumns = {
	createdAt: 'custom',
	name: 'string',
	createdBy: 'string',
	isActive: 'custom',
};
